var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDaoIconMenu = function SvgDaoIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.161,
    height: 19.924
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106117",
    d: "M4.838 8.943a1.034 1.034 0 0 0-.719.3 1.051 1.051 0 0 0 0 1.495l4.938 4.957a1.005 1.005 0 0 0 1.438 0 1.051 1.051 0 0 0 0-1.495L5.557 9.243a1.034 1.034 0 0 0-.719-.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106118",
    d: "M13.829 0a1.034 1.034 0 0 0-.719.3 1.051 1.051 0 0 0 0 1.495l4.938 4.957a1.005 1.005 0 0 0 1.438 0 1.051 1.051 0 0 0 0-1.495L14.548.3a1.034 1.034 0 0 0-.719-.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106119",
    d: "m20.594 15.761-7.756-7.553a.618.618 0 0 0-.43-.181.579.579 0 0 0-.43.181.6.6 0 0 0 0 .859l7.756 7.553a.632.632 0 0 0 .452.181.618.618 0 0 0 .611-.611.764.764 0 0 0-.203-.429Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106120",
    d: "M0 19.924h10v-1.8H0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106121",
    d: "M1.306 18.01h7v-.583a1.322 1.322 0 0 0-1.328-1.307H2.633a1.322 1.322 0 0 0-1.328 1.307Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106122",
    d: "M19.2 13.946a1.01 1.01 0 0 0-.731.3 1.087 1.087 0 0 0 0 1.515l2.923 2.959a1.04 1.04 0 0 0 .731.3 1.01 1.01 0 0 0 .731-.3 1.087 1.087 0 0 0 0-1.515l-2.923-2.959a.981.981 0 0 0-.731-.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 106123",
    d: "m10.47 12.404.869.117a.74.74 0 0 0 .6-.2l4.094-4.128a.773.773 0 0 0 .217-.535V6.605l-3.008-3.008-1.072-.068a.706.706 0 0 0-.551.217L7.561 7.829a.773.773 0 0 0-.217.535l.017.919Z"
  })));
};
export default SvgDaoIconMenu;